<template>
<div>
    <v-toolbar app color="black" dark>
        <v-toolbar-title data-cy="titleBtn">
            <img class="menuLogo ml-0" src="../assets/images/LogoCAMON.png" style="height: 45px" @click="gotoHome()" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout v-if="isDesktopMode()" align-start row justify-center class="red darken-2 p-0 m-0" style="border-radius: 10px 10px 10px 10px"><span class="white--text"><strong>CAM-ON Videos</strong>
            </span>
        </v-layout>
        <v-spacer></v-spacer>
        <v-icon class="mr-4" @click="filterToggle = !filterToggle">search</v-icon>
        <span v-if="isMobileMode()">
            <v-icon v-if="!compatta" @click="compatta = !compatta">compress</v-icon>
            <v-icon v-else @click="compatta = !compatta">expand</v-icon>
        </span>
    </v-toolbar>

    <v-layout align-start row wrap justify-center class="mt-1">
        <v-flex v-if="filterToggle" flex xs12 sm6 md6 lg6>
            <v-text-field style="padding: 3px; color: white; background-color: white" v-model="searchText" label="Cerca cognome o team " outline clearable append-icon="search" @input="changedSearch"></v-text-field>
        </v-flex>
        <v-flex flex xs12 sm12 md12 lg12>
            <v-data-table :items="itemsF" hide-actions hide-headers class="elevation-1 mb-5" style="width: 100%">
                <template slot="items" slot-scope="props">
                    <tr v-if="isDesktopMode() " style="height: 20px" class="mb-0">
                        <td class="pa-0">
                            <table style="color: black; width: 100%" class="mb-3">
                                <tr >
                                    <td colspan="8" class="cardUp pa-1" style="">
                                        <strong style="
                                                    float: left;
                                                    margin: -4px;
                                                    background-color: orange;
                                                    color: black;
                                                    border-radius: 10px 0px 0px
                                                        0px;
                                                    padding: 4px;
                                                    min-width: 30px;
                                                    text-align: center;
                                                ">
                                            Gara {{ props.item.pett }}
                                        </strong>
                                        <strong style="float: left" class="ml-4">
                                            {{ props.item.titolo }}
                                            <span style="color: lightgrey" class="ml-2">
                                                <small>{{
                                                        props.item.Squadra
                                                    }}</small></span>
                                        </strong>

                                        <strong style="
                                                    float: right;
                                                    margin-right: 50px;
                                                    color: white;
                                                ">
                                            <v-btn v-if=" mappaVideo[props.item.pett] != null" class="red darken-2 white--text"  small round @click="
                                                    openVideo(
                                                        mappaVideo[props.item.pett]
                                                    )
                                                ">
                                                <span class="mr-2">Video</span>
                                                <img class="menuLogo ml-0" src="../assets/images/LogoCAMON_alpha.png" style="height: 20px" />
                                            </v-btn>
                                            <span v-else> Video in coda di elaborazione </span>

                                        </strong>
                                    </td>
                                </tr>
                                <tr v-for="n in 6" :key="n">
                                    <td width="3%" class="frazioniTitlePos m-2">
                                        <strong class="mr-2">
                                            {{ n }}
                                        </strong>
                                    </td>
                                    <td width="30%" class="frazioniTitle pl-2">
                                        {{ props.item['p'+n] }}</td>

                                    <td width="5%" class="frazioniTitle pl-2">
                                        {{ props.item['p'+n+'anno'] }}
                                    </td>

                                    <td width="30%" class="frazioniTitle pl-2">
                                        {{ props.item['p'+n+'team'] }}
                                    </td>

                                    <td width="10%" :class="n==1 ? 'frazioniTitleFinalePrimo': 'frazioniTitleFinalePrimo frazioniTitleFinaleAltri'">
                                        {{ props.item['p'+n+'tempo'] }}
                                    </td>

                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr v-if="isMobileMode() " style="height: 20px" class="mb-2">
                        <td class="pa-0">
                            <table style="color: black; width: 100%" class="mb-3">
                                <tr>
                                    <td colspan="3" class="cardUp pa-1" style="">
                                        <strong style="
                                                    float: left;
                                                    margin: -4px;
                                                    background-color: orange;
                                                    color: black;
                                                    border-radius: 10px 0px 0px
                                                        0px;
                                                    padding: 3px;
                                                    min-width: 30px;
                                                    text-align: center;
                                                ">
                                            G{{ props.item.pett }}
                                        </strong>
                                        <strong style="float: left" class="mr-2 ml-4 white--text">
                                            {{ props.item.titolo }}
                                        </strong>
                                    </td>
                                </tr>

                                <tr v-for="n in 6" :key="n">
                                    <td v-if="!compatta" width="70%" class="frazioniTitle pl-2"> <strong class="mr-2">
                                            {{ n }}
                                        </strong>
                                        {{ props.item['p'+n] }}</td>
                                    <td v-if="!compatta" width="30%" :class="n==1 ? 'frazioniTitleFinalePrimo': 'frazioniTitleFinalePrimo frazioniTitleFinaleAltri'">
                                        {{ props.item['p'+n+'tempo'] }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="cardDown frazioniValue">
                                        <v-btn v-if=" mappaVideo[props.item.pett] != null" class="red darken-4 white--text"  small round @click="
                                                    openVideo(
                                                        mappaVideo[props.item.pett]
                                                    )
                                                ">
                                            <span class="mr-2">Video</span>
                                            <img class="menuLogo ml-0" src="../assets/images/LogoCAMON_alpha.png" style="height: 20px" />
                                        </v-btn>
                                        <span v-else> Video in coda di elaborazione </span>
                                    </td>
                                </tr>

                            </table>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex flex xs12 sm12 md12 lg12>
              <v-layout align-start row wrap justify-center class="grey lighten-2" ><span class="black--text p-2 m-2">  Video in caricamento.... 
            </span>
        </v-layout>
           
        </v-flex>
    </v-layout>
    <v-footer fixed class="grey darken-2" style="height: 30px; padding: 10px">
        <v-layout align-start row wrap justify-center class="orange  p-0 m-0" style="border-radius: 10px 10px 10px 10px"><span class="black--text"><strong>Caricati {{numLoaded}} video su {{items.length}}  </strong>
            </span>
        </v-layout>
    </v-footer>
</div>
</template>

<script>
import helper from '../helper';

export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Live',

    data() {
        return {
            items: [],
            itemsF: [],

            compatta: false,
            categoriaSelected: 'TUTTE',
            listaCategorie: ['TUTTE'],
            filterToggle: true,
            filterPreferiti: false,
            listaPreferiti: {},

            searchText: '',

            raceID: null,
            nomeGara: '',

            connection: null,

            snackbar: 'AAA',

            myInterval: null,
            numLoaded: 0,

            mappaVideo: {}
        };
    },

    created() {
        window.addEventListener('keypress', this.doCommand);
    },
    destroyed() {
        window.removeEventListener('keypress', this.doCommand);
    },

    beforeDestroy() {
        console.log('beforeDestroy:');
        //clearInterval(this.myInterval);
    },

    mounted() {
        this.raceID = this.$route.params.raceID;
        this.loadEvento();
    },

    methods: {

        doCommand(e) {
            let cmd = String.fromCharCode(e.keyCode).toLowerCase();
            if (e.keyCode == 13) {
                this.itemsF = this.filteredList();
            }
        },

        openVideo(videoUrl) {
            let _url = videoUrl.replaceAll("https://vimeo.com/", "");
            _url = _url.replaceAll("/", "|");
            console.log(_url);

            this.$router.push('/player/' + (_url));
        },

        _openVideo(link) {
            //  http://localhost:8080/IcronNewGO/generaLetteraPdf/20211248/123456/abcd
            window.open(link, "_blank");

        },

        changedSearch(event) {
            // console.log('Changed:' + event);
            this.searchText = event;

        },

        loadEvento() {

            this.getVideoLinks(this.raceID).then((response) => {
                console.log(response)
                if (response.esito == 'OK') {
                    response.listaLavorazioni.forEach(element => {
                        this.mappaVideo[element.tag] = element.pathRisorsa;
                        this.numLoaded++;
                    });
                }
                this.getVideoData(this.raceID).then((response) => {
                        this.items = this.csvJSON(response);
                        this.itemsF = this.filteredList();
                    });
            });

           // this.myInterval = setInterval(this.refresh, 600000, this);


        },

        refresh() {
            this.numLoaded = 0;
            this.loadEvento();
        },

        gotoHome() {
            this.$router.push('/');
        },

        isMobileMode: function () {
            let res = this.$vuetify.breakpoint.name === 'xs';
            return res;
        },
        isDesktopMode: function () {
            return !this.isMobileMode();
        },
        toggleCompatta() {
            this.compatta = !this.compatta;
        },
        filteredList() {
            var listaSearch = this.items;
            if (this.searchText !== '' && this.searchText != null) {
                listaSearch = this.items.filter((p) => {
                    /*let res =
                        p != null &&
                        p.titolo != null &&
                        p.titolo.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;*/

                    let res2 = false;
                    for (let i = 1; i <= 6; i++) {
                        let key = new String('p' + i);
                        res2 =
                            p != null &&
                            p[key] != null &&
                            p[key].toUpperCase().indexOf(
                                this.searchText.toUpperCase()
                            ) !== -1;

                        if (res2) break;

                        key = new String('p' + i + 'team');
                        res2 =
                            p != null &&
                            p[key] != null &&
                            p[key].toUpperCase().indexOf(
                                this.searchText.toUpperCase()
                            ) !== -1;

                        if (res2) break;

                    }

                    return res2;
                    /*  let res1 =
                          p != null &&
                          p.Squadra != null &&
                          p.Squadra.toUpperCase().indexOf(
                              this.searchText.toUpperCase()
                          ) !== -1;

                      let resTot = res || res1 || res2;
                      return resTot;*/
                });
            }

            return listaSearch;
        },
    },
};
</script>

<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

.ok {
    text-align: center;
    color: white;
    background-color: green;
    border-radius: 0px 0px 3px 3px;
}

.frazioniTitle {
    text-align: left;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniTitleFinale {
    text-align: center;
    background-color: orange;
    color: black;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 5px 5px;
    font-weight: bold;
}

.frazioniTitleFinalePrimo {
    text-align: right;
    background-color: orange;
    color: black;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 0px 5px 5px 0px;
    font-weight: bold;
}

.frazioniTitleFinaleAltri {
    background-color: rgb(182, 177, 177);

}

.frazioniTitlePos {
    text-align: right;
    background-color: rgb(90, 89, 89);
    color: white;
    font-style: italic;
    border-radius: 5px 0px 0px 5px;
    font-weight: bold;
}

.cardUp {
    background-color: rgb(0, 0, 0);
    color: white;
    _border: 1px solid lightgray;
    border-radius: 20px 10px 0px 0px;
}

.cardDown {
    background-color: rgb(0, 0, 0);
    color: white;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 10px 10px;
}
</style>
